// extracted by mini-css-extract-plugin
export default {"tooltip":"dX-z","arrow":"eX-z"};